import { Component, OnInit } from '@angular/core';
import { ProfileService } from '../common/core/auth/profile.service';
import { I18NService } from '../common/core/i18n/i18n.service';
import { WelcomeDialogDataService } from './welcome-dialog-data.service';
import { DIALOG_VERSION, DIALOG_VERSION_KEY } from './dialog-version';
import { WindowRef } from '../common/core/domain/window-ref';

@Component({
    selector: 'adminui-welcome-dialog',
    imports: [],
    templateUrl: './welcome-dialog.component.html'
})
export class WelcomeDialogComponent implements OnInit {
  readonly translationIndex = 'welcomeDialog';

  message: { [key: string]: string; } = {};
  username!: string;


  constructor(private profileService: ProfileService, private i18nService: I18NService,
    private welcomeDialogDataService: WelcomeDialogDataService, private windowRef: WindowRef) { }

  ngOnInit(): void {
    this.message = { ...this.i18nService.messages[this.translationIndex] };
    this.username = this.profileService.profile.given_name;
  }

  close(): void {
    localStorage.setItem(DIALOG_VERSION_KEY, DIALOG_VERSION);
    this.welcomeDialogDataService.closeDialog();
  }

  ok(): void {
    let url = "https://docs.vismasoftware.no/admin/";
    const locale = this.profileService.profile.locale;
    switch (locale) {
      case 'nb-NO': url = "https://docs.vismasoftware.no/no/admin/";
        break;
      case 'sv-SE': url = "https://docs.vismasoftware.no/sv/admin/";
        break;
    }
    this.windowRef.open(url, '_blank');
    localStorage.setItem(DIALOG_VERSION_KEY, DIALOG_VERSION);
    this.welcomeDialogDataService.closeDialog();
  }
}
